<app-dialog-header [description]="fixedScope ? 'Choose the columns for your CSV file.' : 'Choose the columns and rows for your CSV file.'" (dismissed)="dismissed.emit()">{{ title }}</app-dialog-header>
<div class="modal-body" [attr.aria-busy]="busy">
  <p class="ia-export-scope" role="status">
    <ng-container *ngIf="fixedScope; else selectableScope">{{ fixedScope }}</ng-container>
    <ng-template #selectableScope>
    <ng-container *ngIf="selectionOnly; else regularScope">{{ selectionCount | number }} selected {{ rowsLabel }}</ng-container>
    <ng-template #regularScope>
      <ng-container *ngIf="form?.value.isAll; else currentPage">{{ totalCount | number }} matching {{ rowsLabel }}</ng-container>
      <ng-template #currentPage>Current page · {{ pageCount | number }} {{ rowsLabel }}</ng-template>
    </ng-template>
    </ng-template>
  </p>
  <p *ngIf="error" class="ia-export-error" role="alert">{{ error }}</p>
  <form *ngIf="form" [formGroup]="form" (submit)="$event.preventDefault()">
    <fieldset [disabled]="busy" [attr.inert]="busy ? '' : null">
      <div class="ia-export-columns-heading">
        <h3>Columns</h3>
        <span>{{ form.get('column')?.value?.length || 0 }} selected</span>
      </div>
      <kt-select [items]="columns" formControlName="column" bindLabel="label" ariaLabel="Columns to export"
        placeholder="Choose columns" appendTo="body"></kt-select>
      <p class="ia-export-help">Choose at least one column.</p>
      <label *ngIf="!selectionOnly && !fixedScope" class="ia-export-all">
        <input type="checkbox" formControlName="isAll"> All matching {{ rowsLabel }}
      </label>
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismissed.emit()">{{ busy ? 'Close' : 'Cancel' }}</button>
  <button type="button" class="btn btn-primary" [disabled]="!canExport" (click)="export()">{{ busy ? 'Exporting…' : 'Export CSV' }}</button>
</div>
